import { Link, useHistory } from 'react-router-dom';
import { useAppSelector } from '../../app/hooks';
import { selectGovBr } from '../../auth/authSlice';
import { BaseProps } from '../../common/BaseProps';
import {
  mostrarComprovante,
  mostrarConsultaCompleta,
  mostrarConsultaCpf,
  mostrarConsultaEscolaridade,
  mostrarConsultaPendencias,
  mostrarConsultaRenda,
  mostrarConsultaSimples,
  mostrarExclusaoCadastralTutorial,
  mostrarMeusBeneficios,
  mostrarPostosAtendimento,
  mostrarProgramasSociais,
  mostrarValidacaoComprovante
} from '../../features/Home/Home';
import { selectLogado } from '../../features/IdentificacaoPositiva/identificacaoPositivaSlice';
import { selectPerfilCompleto, selectPermiteRemoverFamiliaCadUnico, selectSelecionouSolicitacaoCadastramento, selectSituacaoCadastroFamilia } from '../../features/Perfil/perfilSlice';
import { SituacaoCadastroFamiliaUsuario } from '../../model/SituacaoCadastroFamiliaUsuario';
import UserNavBar from '../UserNavBar/UserNavBar';
import styles from './NavBar.module.css';
import { iniciarSolicitacaoCadastramento, verificarSeFamiliaEstahCadastrada } from '../../common/solicitacaoUtils';

interface Props extends BaseProps {
  fixed?: boolean;
  stoppedTitle?: boolean;
  title?: string;
  titleBarraAuxiliar?: string;
  titleBarraAuxiliarHelp?: () => void;
  barraAuxiliarLogout?: boolean;
  padraoInicial?: boolean,
  hideArrow?: boolean;
  goBack?: () => any;
  separator?: boolean;
  logout?: any;
  userNav?: boolean;
  barraAuxiliar?: boolean;
  caixaMensagens?: any;
}

const NavBar: React.FC<Props> = (props) => {
  const history = useHistory();

  const perfil = useAppSelector(selectPerfilCompleto);
  const govBrLogado = useAppSelector(selectGovBr).logado;
  const situacaoCadastroFamilia = useAppSelector(selectSituacaoCadastroFamilia);
  const isAuthenticatedIdPositiva = useAppSelector(selectLogado);
  const permiteRemoverFamiliaCadUnico = useAppSelector(selectPermiteRemoverFamiliaCadUnico);
  const selecionouSolicitacaoCadastramento = useAppSelector(selectSelecionouSolicitacaoCadastramento);

  const PERMITE_PRE_CADASTRO_USUARIO = situacaoCadastroFamilia?.situacaoCadastroFamiliaUsuario !== SituacaoCadastroFamiliaUsuario.USUARIO_COM_FAMILIA_CADASTRADA;

  const goBack = () => {
    if (props.goBack) {
      return props.goBack();
    }
    history.goBack();
  };

  const isLogadoGovBr = () => {
    return (govBrLogado && situacaoCadastroFamilia);
  };
  const isLogadoIdPositiva = () => {
    return !!isAuthenticatedIdPositiva;
  };
  const isLogado = () => {
    return isLogadoGovBr() || isLogadoIdPositiva();
  };

  const aptoPreCadastro = () => {
    return (
      situacaoCadastroFamilia?.situacaoCadastroFamiliaUsuario ===
      SituacaoCadastroFamiliaUsuario.USUARIO_APTO_A_COMECAR_O_PRE_CADASTRO ||
      situacaoCadastroFamilia?.situacaoCadastroFamiliaUsuario ===
      SituacaoCadastroFamiliaUsuario.USUARIO_COM_PRAZO_CADASTRO_DECORRIDO ||
      situacaoCadastroFamilia?.situacaoCadastroFamiliaUsuario ===
      SituacaoCadastroFamiliaUsuario.USUARIO_COM_FAMILIA_COM_PRE_CADASTRO_INICIADO ||
      situacaoCadastroFamilia?.situacaoCadastroFamiliaUsuario ===
      SituacaoCadastroFamiliaUsuario.USUARIO_COM_FAMILIA_COM_PRE_CADASTRO_FINALIZADO_NAO_ENVIADO ||
      situacaoCadastroFamilia?.situacaoCadastroFamiliaUsuario ===
      SituacaoCadastroFamiliaUsuario.USUARIO_COM_FAMILIA_COM_PRE_CADASTRO_FINALIZADO_ENVIADO ||
      situacaoCadastroFamilia?.situacaoCadastroFamiliaUsuario ===
      SituacaoCadastroFamiliaUsuario.USUARIO_COM_FAMILIA_COM_PRE_CADASTRO_FINALIZADO_ENVIADO_REJEITADO
    );
  };

  const styleContainer = () => {
    if (props.padraoInicial) return styles.container;

    if (props.barraAuxiliar) return styles.containerBarraAuxiliar;

    return styles.container;
  }

  const styleBarraAuxiliar = () => {
    if (props.stoppedTitle) return '';
    if (props.fixed) return styles.fixed;

    return '';
  }

  return (
    <div className={`${styleContainer()}`}>
      <div className={styles.webNavBarWrapper}>
        <div className={styles.webNavBar}>
          <div className={styles.menuWrapper}>
            <Link to="/home">
              <div className={styles.menuItem}>
                <i className={`fas fa-home`} />
              </div>
            </Link>
            {!isLogado() && (
              <>
                <div className={`${styles.menuItem} ${aptoPreCadastro() ? styles.disabled : ''}`}
                  onClick={() => aptoPreCadastro() ? null : mostrarConsultaCpf(history)}>
                  <span>Consulta por CPF</span>
                </div>
                {/* <div
                  className={`${styles.menuItem} ${aptoPreCadastro() ? styles.disabled : ''}`}
                  onClick={() => aptoPreCadastro() ? null : mostrarIdentificacaoPositiva(history)}
                >
                  <span>Consulta simples</span>
                </div> */}
              </>
            )}

            {isLogadoGovBr() && (
              <>
                <div
                  className={`${styles.menuItem} ${selecionouSolicitacaoCadastramento || (PERMITE_PRE_CADASTRO_USUARIO && !perfil?.temRL) ? styles.disabled : ''}`}
                  onClick={() => mostrarConsultaPendencias(history)}
                >
                  <span>Pendências do cadastro</span>
                </div>
                <div
                  className={`${styles.menuItem} ${selecionouSolicitacaoCadastramento || (PERMITE_PRE_CADASTRO_USUARIO && !perfil?.temRL) ? styles.disabled : ''}`}
                  onClick={() => mostrarConsultaCompleta(history)}
                >
                  <span>Consulta ao formulário</span>
                </div>
                {/*<div
                  className={`${styles.menuItem} ${!selecionouSolicitacaoCadastramento || !aptoPreCadastro() || verificarSeFamiliaEstahCadastrada(situacaoCadastroFamilia, perfil, selecionouSolicitacaoCadastramento) ? styles.disabled : ''}`}
                  onClick={() => iniciarSolicitacaoCadastramento(history, situacaoCadastroFamilia)}
                >
                  <span>Solicitação de cadastramento</span>
                </div>*/}
                {/* <div
                  // className={`${styles.menuItem} ${aptoPreCadastro() ? styles.disabled : ''}`}
                  className={`${styles.menuItem} ${styles.disabled}`}
                  // onClick={() => aptoPreCadastro() ? null : mostrarAtualizacaoCadastralPorConfirmacao(history)}
                >
                  <span>Atualização cadastral</span>
                </div> */}
                <div
                  className={`${styles.menuItem} ${selecionouSolicitacaoCadastramento || (PERMITE_PRE_CADASTRO_USUARIO && !perfil?.temRL) ? styles.disabled : ''}`}
                  onClick={() => mostrarMeusBeneficios(history)}
                >
                  <span>Meus benefícios</span>
                </div>
                <div
                  className={`${styles.menuItem} ${selecionouSolicitacaoCadastramento || (PERMITE_PRE_CADASTRO_USUARIO && !perfil?.temRL) ? styles.disabled : ''}`}
                  onClick={() => mostrarConsultaRenda(history)}
                >
                  <span>Consulta de renda CNIS</span>
                </div>
                <div
                  className={`${styles.menuItem} ${selecionouSolicitacaoCadastramento || (PERMITE_PRE_CADASTRO_USUARIO && !perfil?.temRL) ? styles.disabled : ''}`}
                  onClick={() => mostrarConsultaEscolaridade(history)}
                >
                  <span>Consulta de escolaridade</span>
                </div>
                {permiteRemoverFamiliaCadUnico && (
                  <div
                    className={styles.menuItem}
                    onClick={() => mostrarExclusaoCadastralTutorial(history, false)}
                  >
                    <span>Cancele o seu cadastro</span>
                  </div>
                )}
              </>
            )}

            {isLogadoIdPositiva() && (
              <div
                className={`${styles.menuItem} ${aptoPreCadastro() ? styles.disabled : ''}`}
                onClick={() => aptoPreCadastro() ? null : mostrarConsultaSimples(history)}
              >
                <span>Dados resumidos da família</span>
              </div>
            )}

            {(isLogadoGovBr() || isLogadoIdPositiva()) && (
              <div
                className={`${styles.menuItem} ${selecionouSolicitacaoCadastramento || (PERMITE_PRE_CADASTRO_USUARIO && !perfil?.temRL) ? styles.disabled : ''}`}
                onClick={() => mostrarComprovante(history)}
              >
                <span>Comprovante de cadastro</span>
              </div>
            )}

            <div className={styles.menuItem} onClick={() => mostrarPostosAtendimento(history)}>
              <span>Postos de atendimento</span>
            </div>
            <div className={styles.menuItem} onClick={() => mostrarProgramasSociais(history)}>
              <span>Programas sociais</span>
            </div>
            <div className={styles.menuItem} onClick={() => mostrarValidacaoComprovante(history)}>
              <span>Validar comprovante</span>
            </div>
          </div>
          {perfil && (
            <div className={styles.menuWrapper}>
              <Link to="/perfil">
                <div className={styles.menuItem}>
                  <span className={styles.itemText}>Perfil</span>
                  <i className={`fas fa-user-circle`} />
                </div>
              </Link>
            </div>
          )}
        </div>
      </div>
      {props.barraAuxiliar && (
        <div className={`${styles.headerWrapper} ${styleBarraAuxiliar()}`}>
          <div className={`${styles.header} ${props.separator ? styles.separator : ''}`}>
            {!props.hideArrow && (
              <div className={styles.arrow} onClick={goBack}>
                <i className="fas fa-arrow-left"></i>
              </div>
            )}
            {props.titleBarraAuxiliar && (
              <div className={styles.title}>
                {props.titleBarraAuxiliar}
                {props.titleBarraAuxiliarHelp && (
                  <i
                    className={`fas fa-question-circle ${styles.helpIcon}`}
                    onClick={props.titleBarraAuxiliarHelp}
                  />
                )}
              </div>
            )}
            {!props.titleBarraAuxiliar && (
              <div className={styles.defaultTitle}>
                <strong>cadastro único</strong>
              </div>
            )}
            {(props.barraAuxiliarLogout) && (
              <div className={styles.logout} onClick={props.logout}>
                <i className="fas fa-sign-out-alt"></i>
              </div>
            )}
          </div>
        </div>
      )}
      {props.userNav && (
        <UserNavBar
          name={props.title}
          fixed={props.fixed}
          logout={props.logout}
          caixaMensagens={props.caixaMensagens}
        />
      )}
    </div>
  );
};

export default NavBar;
